import React from 'react';
import LegalPage from '../../components/LegalPage';

export default function ProviderDisclaimer() {
  return (
    <LegalPage eyebrow="Legal" title="Third-Party Provider & Booking Disclaimer" updated="July 2025">
      <p>Waan Travel Pte. Ltd., operator of Cheapora (www.cheapora.com), operates a travel search and comparison platform. Once live partner integrations are activated, you may be redirected to a third-party provider (such as an airline, online travel agency, hotel supplier or car-rental provider) to complete your booking.</p>
      <h2>Provider responsibility</h2>
      <p>Subject to the applicable partner agreement, the relevant third-party provider is generally responsible for:</p>
      <ul>
        <li>Final pricing, taxes and fees;</li>
        <li>Availability;</li>
        <li>Payment collection and processing;</li>
        <li>Booking confirmation, tickets and vouchers;</li>
        <li>Cancellation, amendment and refund policies;</li>
        <li>Customer service in connection with the product or service supplied.</li>
      </ul>
      <h2>No representations</h2>
      <p>Whilst Cheapora selects reputable partners, we make no representations or warranties about the products or services supplied by third-party providers beyond those permitted by law.</p>
      <h2>Contact</h2>
      <p><a href="mailto:admin@waantravel.com">admin@waantravel.com</a></p>
    </LegalPage>
  );
}
